// extracted by mini-css-extract-plugin
export default {"CheckUp":"CheckUp_CheckUp__AHckQ"};